exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".number_widget{color:#fff;position:relative!important;top:0!important;left:0!important;transform:translate(0, 0)!important;width:100%!important;height:100%!important;text-align:center;margin:0;display:table}.number_widget h3{color:#fff;font-size:18px}.number_widget h2{color:#fff;margin:0;display:table-cell;vertical-align:middle}.box>div,.number_widget h2{width:100%;height:100%}.bignumberText{font-family:Roboto,sans-serif;font-weight:500;letter-spacing:-.7;color:#fff;fill:#fff}.NumberWidget i.fa.fa-check{display:none}.NumberWidget svg>text{font-size:80%}.budget_achieved_numberwidget{background:#5cb85c}.budget_achieved_numberwidget>i.fa.fa-check{display:block;position:absolute;left:50%;top:50%;transform:translate(-50%, -50%);font-size:17pc;color:hsla(0,0%,100%,.125);z-index:2}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/autoprefixer-loader?browsers=last 2 version!./~/sass-loader?outputStyle=expanded!./client/components/Widgets/NumberWidget.scss
 ** module id = 774
 ** module chunks = 0
 **/